import { getApi } from "./api";

export const sideBarByRoleId = async (RoleId) => {
    return await getApi(
        `/User/sidebar/${RoleId}`
    );
};
export const GetAllTeleCallerWithParent = async () => {
    return await getApi(`/User/GetAllTeleCallerWithParent`);
};